export default __webpack_public_path__ + "static/3-489182d5bedca6ec0308bacf52fdc303.jpeg";